import React, { useEffect, useState } from "react"
import Table from "components/Table";

export const columns = [
    {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 250,
    },
    {
        label: "Region",
        field: "region.name",
        sort: "asc",
        width: 250,
    },
    {
        label: "Actions",
        field: "action",
        sort: "asc",
        width: 100,
    },
];


export default function District(props){
    return <Table 
            columns={columns}
            itemType = "district"
            itemType_verbose="District"
    /> 
}